// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ih2g","colBig":"styles_colBig__-s-fS","colSmall":"styles_colSmall__30mJj"};